import React from 'react'
import {
    Box,
    Divider,
    Flex,
    IconButton,
    Input,
    InputGroup,
    InputRightElement,
    Text,
    Avatar, AvatarBadge, AvatarGroup,
    Stack,
    
  } from "@chakra-ui/react";

const Message = () => {
  return (
    <>
    <Box display='flex' justifyContent='center'>
    <Text position='absolute' fontSize='2rem' bgColor={'whatsapp.300'} padding='1rem' ml='50rem' borderRadius='2rem' minWidth='2.5' maxWidth='100rem' paddingTop='1.5rem' pb='1.5rem'>Hello my name is manthan and i want you sdfsdfdsfsf</Text>
    </Box>
    </>
  )
}

export default Message